import { render, staticRenderFns } from "./Reschool.vue?vue&type=template&id=35e1d768&scoped=true&"
import script from "./Reschool.vue?vue&type=script&lang=js&"
export * from "./Reschool.vue?vue&type=script&lang=js&"
import style0 from "./Reschool.vue?vue&type=style&index=0&id=35e1d768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1d768",
  null
  
)

export default component.exports